export default function fastTransferManager(fetch, baseUrl) {
  return {
    // GET Fast Transfer Config
    getFastTransferConfig() {
      return fetch.get(`${baseUrl}`);
    },

    // PUT Fast Transfer Config
    updateFastTransferConfig({ payload }) {
      return fetch.put(`${baseUrl}`, payload);
    }
  };
}
